import { isNumber } from 'lodash';
import { fmtPrice } from '@upstart/harmony/lib/formatter';
import React from 'react';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import { ValidateResponseResult } from '@upstart/harmony/lib/response-utils';

const OfferFinancingReview: React.FC<{
  response?: FinanceResponse;
  validations?: ValidateResponseResult;
  showDealerFee: boolean;
  isEditable: boolean;
}> = ({ response, validations, isEditable, showDealerFee }) => (
  <div className="flex flex-wrap" data-testid="OfferFinancingReview">
    {isNumber(response?.data?.financeAmount) &&
      isNumber(response?.data?.dealerReserve) && (
        <div className="flex pt-10 pr-25">
          <div className="offer-label pr-10">Dealer Flat</div>
          <div data-testid="DealerReserveValue">
            {validations?.isInvalid
              ? 'N/A'
              : fmtPrice(
                  (response?.data?.financeAmount ?? 0) *
                    (response?.data?.dealerReserve ?? 0),
                )}
          </div>
        </div>
      )}
    {showDealerFee && (
      <div className="flex pt-10 pr-25">
        <div className="offer-label pr-10">Dealer Fee</div>
        <div data-testid="DealerFeeValue">
          {validations?.isInvalid
            ? 'N/A'
            : fmtPrice(
                (response?.data?.financeAmount ?? 0) *
                  (response?.data?.dealerFeePercentage ?? 0),
              )}
        </div>
      </div>
    )}
    {isNumber(response?.data?.financeAmount) && (
      <div className="flex pt-10 pr-25">
        <div className="offer-label pr-10">Finance Amount</div>
        <div data-testid="FinanceAmountValue">
          {fmtPrice(response?.data?.financeAmount ?? 0)}
        </div>
      </div>
    )}
    {response && isNumber(response?.calculatedBackendAmount) && (
      <div className="flex pt-10 pr-25">
        <div className="offer-label pr-10">Backend Amount</div>
        <div data-testid="BackendAmountValue">
          {fmtPrice(response.calculatedBackendAmount)}
        </div>
      </div>
    )}
    {isNumber(response?.data?.downPayment) && !isEditable && (
      <div className="flex pt-10">
        <div className="offer-label pr-10">Down Payment</div>
        <div data-testid="DownPaymentValue">
          {fmtPrice(response?.data?.downPayment ?? 0)}
        </div>
      </div>
    )}
  </div>
);

export default OfferFinancingReview;
